import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import PageLayout from '../components/PageLayout';
import PageBanner from '../components/PageBanner';
import SEO from '../components/SEO';
import RichContent from '../components/RichContent';
import API from '../api';
import { useLanguage } from '../context/LanguageContext';

const BASE = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL.replace('/api', '') : 'http://localhost:5000';

function formatDate(str, language) {
  if (!str) return '';
  return new Date(str).toLocaleDateString(language === 'ja' ? 'ja-JP' : 'en-US', { year: 'numeric', month: 'long', day: 'numeric' });
}

export default function PromotionDetail() {
  const { t, language } = useLanguage();
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    API.get(`/promotions/${slug}`)
      .then(r => setPost(r.data))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [slug]);

  const imgSrc = (url) => url?.startsWith('/') ? `${BASE}${url}` : url;

  if (!loading && (notFound || !post)) {
    return (
      <PageLayout>
        <PageBanner en="NEWS" title={t('promotions.notFoundTitle')} breadcrumbs={[{ label: t('promotions.title'), to: '/promotional' }, { label: t('promotions.notFoundTitle') }]} />
        <section className="py-20 text-center">
          <p className="text-gray-400 text-lg mb-6">{t('promotions.notFoundMessage')}</p>
          <Link to="/promotional" className="btn-primary text-sm">{t('promotions.backToPromotions')}</Link>
        </section>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <SEO title={post?.title} description={post?.excerpt} />
      <PageBanner en="NEWS" title={post?.title || ''} breadcrumbs={[{ label: t('promotions.title'), to: '/promotional' }, { label: post?.title || '' }]} />

      <section className="pt-6 pb-20 lg:pb-28 bg-white">
        <div className="w-[90%] max-w-3xl mx-auto">
          <Link to="/promotional" className="inline-flex items-center gap-1.5 text-sm text-gray-500 hover:text-primary transition-colors mb-8">
            <ArrowLeftIcon className="w-3.5 h-3.5" /> {t('promotions.backToPromotions')}
          </Link>

          {loading ? (
            <div className="space-y-4 animate-pulse">
              <div className="aspect-[16/9] bg-gray-100" />
              <div className="h-24 bg-gray-100" />
            </div>
          ) : (
            <>
              <p className="text-xs text-gray-400 mb-4">{formatDate(post.published_at, language)}</p>
              {post.image_url && (
                <div className="aspect-[16/9] bg-gray-100 overflow-hidden mb-8">
                  <img src={imgSrc(post.image_url)} alt={post.title} className="w-full h-full object-cover" />
                </div>
              )}
              <RichContent html={post.content} />
            </>
          )}
        </div>
      </section>
    </PageLayout>
  );
}
